import styled from 'styled-components';
import { Check } from 'ui/toyota/outlines';

export default {
    Label: styled.label`
        display: flex;
        align-items: center;
    `,
    Text: styled.span`
        margin-top: -1px;
        font-family: Toyota Display;
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 21px;
        letter-spacing: 0;
        color: #000000;
        text-align: left;
    `,
    Link: styled.a`
        margin-top: -2px;
        font-family: Toyota Display;
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 21px;
        letter-spacing: 0;
        color: #000000;
        cursor: pointer;
        text-decoration: underline;
    `,
    Input: styled.input.attrs({ className: 'checkbox-text' })`
        position: absolute;
        opacity: 0;
        cursor: pointer;
    `,
    InputMocked: styled.div.attrs({ className: 'input-mocked' })`
        width: 20px;
        min-width: 20px;
        height: 20px;
        border: 2px solid ${props => props.errorOnAgreenment ? '#E50000' : '#E0E0E0'};
        box-sizing: border-box;
        border-radius: 4px;
        background: #fff;
        background-image: ${props => props.checked ? `url(${Check})` : 'none'};
        background-repeat: no-repeat;
        background-position: center 25%;
        transition: all .2s;
        margin-right: 15px;
        cursor: pointer;
    `,
    CheckboxError: styled.span.attrs({ className: 'checkbox-error' })`
        bottom: -10px;
        margin-top: 5px;
        font-family: Toyota Display;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        color: #E50000;
        float: left;
        text-align: left;
        margin-left: 35px;
        @media (min-width: 700px) {
            margin-left: 0;
        }
    `,
};
